import { VLandAreaComponentRemote } from "../api/land-area";
import { VAssetClassSizeRemote } from "../api/size";
import { convertSize, VAssetClassSize } from "../common/size";

export function mapVAssetClassSizeRemoteToDomain(remote: VAssetClassSizeRemote[]): VAssetClassSize[] {
  return remote.map(item => ({
    standardMeasurementId: item.standard_measurement_id,
    standardMeasurementName: item.standard_measurement_name,
    unitOfAreaMeasurementId: item.unit_of_area_measurement_id,
    unitOfAreaMeasurementAcronym: item.unit_of_area_measurement_acronym,
    size: item.size
  }))
}

export function mapVLandSize(landAreaComponents: VLandAreaComponentRemote[]): VAssetClassSize[] {
  if (landAreaComponents.length == 0) {
    return [{
      standardMeasurementId: 10,
      standardMeasurementName: '(International) - ILMS',
      unitOfAreaMeasurementId: -1,
      unitOfAreaMeasurementAcronym: 'Unknown',
      size: 0
    }]
  }
  const unitAreameasurementId = landAreaComponents[0].unit_area_measurement_id
  const unitAreaMeasurementAcronym = landAreaComponents[0].unit_area_measurement_acronym
  const total = landAreaComponents.reduce((acc, component) => {
    acc = acc + convertSize(component.surface, component.unit_area_measurement_id, unitAreameasurementId)
    return acc
  }, 0)
  const size: VAssetClassSize = {
    standardMeasurementId: 10,
    standardMeasurementName: '(International) - ILMS',
    unitOfAreaMeasurementId: unitAreameasurementId,
    unitOfAreaMeasurementAcronym: unitAreaMeasurementAcronym,
    size: total
  }
  return [size]
}